import { currentParams, stringifyParams } from 'helpers/querystring'
import { useEffect, useState } from 'react'

const listeners = []

function notify() {
  listeners.forEach((listener) => listener())
}

const useUrlParams = () => {
  const [urlParams, setUrlParams] = useState(currentParams())

  function handleChange() {
    setUrlParams(currentParams())
  }

  useEffect(() => {
    window.addEventListener('popstate', handleChange)
    return () => window.removeEventListener('popstate', handleChange)
  }, [])

  useEffect(() => {
    listeners.push(handleChange)
    return () => listeners.splice(listeners.indexOf(handleChange), 1)
  }, [])

  const handlePushState = (params, path = '') => {
    const queryString = stringifyParams(params)
    const currentQueryString = window.location.search?.substring(1)

    if (queryString !== currentQueryString) {
      let actualQueryString = `${path}?${queryString}`
      if (window.location.hash?.substring(1)) {
        actualQueryString += `#${window.location.hash?.substring(1).toLocaleLowerCase()}`
      }
      history.pushState(params, null, actualQueryString) // will automatically set new url params through event popState
      window.dispatchEvent(new Event('search')) // TODO: find better solution to propagate to other components
      notify()
    }
  }

  const updateUrlParams = (params, path) => {
    handlePushState({ ...urlParams, ...params }, path) // keep current params, append new
  }
  const replaceUrlParams = (params, path) => {
    handlePushState(params, path)
  }

  return {
    urlParams,
    updateUrlParams,
    replaceUrlParams,
  }
}

export default useUrlParams
